import type { ConsentDocument } from '../graphql/generated/graphql';

export type GroupedConsent = {
    type: string;
    documents: ConsentDocument[];
};

export const groupConsentsConsecutively = (
    consents: ConsentDocument[]
): GroupedConsent[] => {
    if (!consents?.length) return [];

    const sortedConsents = consents.toSorted(
        (a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0)
    );

    const groups = sortedConsents.reduce<GroupedConsent[]>((acc, consent) => {
        const lastGroup = acc[acc.length - 1];

        if (!lastGroup || lastGroup.type !== consent.consentType) {
            acc.push({ type: consent.consentType, documents: [consent] });
        } else {
            lastGroup.documents.push(consent);
        }

        return acc;
    }, []);

    return groups;
};
